import React from "react";
import { Tooltip, IconButton, Box } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const CopyToClipBoardButton = (props: { algoId: string }) => {
  const CopyToClipBoard = (algoId: string) => {
    navigator.clipboard.writeText(algoId);
    setTitle("Copied!");
    setTimeout(() => {
      setTitle(algoId);
    }, 1000);
  };

  const [title, setTitle] = React.useState(props.algoId);

  return (
    <Box>
      <Tooltip title={title}>
        <IconButton
          sx={{ padding: 0 }}
          onClick={() => CopyToClipBoard(props.algoId)}
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export { CopyToClipBoardButton };
